import { z } from "zod";
import {
  VehicleTypeSchema,
  createVehicleTypeSchema,
  updateVehicleTypeSchema,
} from "@/lib/validations/vehicles/vehicle-type";

/** Complete vehicle type with all fields */
export type VehicleType = z.infer<typeof VehicleTypeSchema>;

/** Type for creating a new vehicle type */
export type CreateVehicleTypeInput = z.infer<typeof createVehicleTypeSchema>;

/** Type for updating an existing vehicle type */
export type UpdateVehicleTypeInput = z.infer<typeof updateVehicleTypeSchema>;

/** Fields that can be edited in a vehicle type */
export type VehicleTypeEditableField = "name" | "description";

/** Interface defining permissions for vehicle type fields */
export interface VehicleTypeFieldPermissions {
  editable: VehicleTypeEditableField[];
  viewable: VehicleTypeEditableField[];
}

/** Fields that can be used for sorting vehicle types */
export const VehicleTypeSortable = ["name", "created", "updated"] as const;
export type VehicleTypeSortField = (typeof VehicleTypeSortable)[number];

/** Simple vehicle type with only id, name, and image */
export type SimpleVehicleType = {
  id: string;
  name: string;
  image: string | null;
};
